const DEFAULT_SLIDER_SETTINGS = {
  slidesPerView: 1,
  spaceBetween: 12,
};

const BREAKPOINTS_WITH_LEFT_SIDEBAR = {
  648: { slidesPerView: 2 },
  988: { slidesPerView: 3 },
  1280: { slidesPerView: 2 },
  1574: { slidesPerView: 3 },
  1894: { slidesPerView: 4 },
  2214: { slidesPerView: 5 },
  2534: { slidesPerView: 6 },
  2854: { slidesPerView: 7 },
  3174: { slidesPerView: 8 },
};

const BREAKPOINTS_WITHOUT_LEFT_SIDEBAR = {
  640: { slidesPerView: 2 },
  1000: { slidesPerView: 3 },
  1280: { slidesPerView: 2 },
  1342: { slidesPerView: 3 },
  1662: { slidesPerView: 4 },
  1982: { slidesPerView: 5 },
  2302: { slidesPerView: 6 },
  2622: { slidesPerView: 7 },
  2942: { slidesPerView: 8 },
};

const BREAKPOINTS_WITH_COLLAPSED_LEFT_SIDEBAR = {
  640: { slidesPerView: 2 },
  1000: { slidesPerView: 3 },
  1280: { slidesPerView: 2 },
  1438: { slidesPerView: 3 },
  1758: { slidesPerView: 4 },
  2078: { slidesPerView: 5 },
  2398: { slidesPerView: 6 },
  2718: { slidesPerView: 7 },
  3038: { slidesPerView: 8 },
};

export const getSliderSettings = ({ isWithLeftSidebar, isLeftSidebarCollapsed }) => ({
  ...DEFAULT_SLIDER_SETTINGS,
  breakpoints: !isWithLeftSidebar
    ? BREAKPOINTS_WITHOUT_LEFT_SIDEBAR
    : (isLeftSidebarCollapsed && BREAKPOINTS_WITH_COLLAPSED_LEFT_SIDEBAR) || BREAKPOINTS_WITH_LEFT_SIDEBAR,
});
